<template>
  <v-form ref="form" >
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="planningItemsList"
          item-value="id"
          item-text="name"
          :search-input.sync="itemsSearch"
          no-filter
          @input="selectItem"
          no-data-text="Nenhum Item encontrado, faça outra busca"
          :hint="planningItemAdditionalInfo(entry.item)"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{planningItemAdditionalInfo(data.item)}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete> 
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade"
          :disabled="!entry.itemId || readOnly"
          @update:inputData="changeQuantity"
          :key="quantityKey + 'quantityKey'"
          autocomplete="off"
          :suffix="entry.item ? entry.item.unit.name : ''"
        />
        <!-- :suffix="entry.item ? entry.item.unit.name : ''" -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="applicationDose"
          mask-type="currency_10d"
          label="Dose de Aplicação"
          :disabled="!entry.itemId || readOnly"
          @update:inputData="changeApplicationDose"
          :key="applicationDoseKey + 'applicationDoseKey'"
          autocomplete="off"
          :suffix="entry.item ? entry.item.unit.name + '/ha' : ''"
          :hint="periodAreaHint"
          persistent-hint
        />
        <!-- :suffix="entry.item ? entry.item.unit.name : ''" -->
      </v-col>

      <v-col cols="12" sm="4">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('unitPrice')"
          :inputData.sync="entry.unitPrice"
          mask-type="currency_10d"
          label="Preço Unitário"
          prefix="R$"
          :suffix="entry.item ? 'por ' + entry.item.unit.name : ''"
          :disabled="!entry.itemId || readOnly"
          :key="unitPriceKey"
          @update:inputData="changeUnitPrice"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="4">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('price')"
          :inputData.sync="entry.price"
          mask-type="currency_10d"
          label="Preço Total"
          prefix="R$"
          :disabled="!entry.itemId || readOnly"
          :key="totalPriceKey"
          @update:inputData="changeTotalPrice"
          autocomplete="off"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      planningItemsList: [],
      PlanningItemsListLoading: false,
      renderComponent: true,
      itemsSearch: "",
      unitPriceKey: 1,
      totalPriceKey: -1,
      applicationDose: 0,
      applicationDoseKey: 0,
      quantityKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    planningOperation: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("planning_item", this.entry.item)
    if (this.entry.item) {
      this.planningItemsList = [this.entry.item];
      this.selectItem();
      this.updateApplicationDose();
    }
  },
  mounted() {
  },
  computed: {
    periodAreaHint: function() {
      let periodsTotalArea = this.planningOperation.periods.map(item => item.area).reduce((a, b) => a + b, 0)
      return "Área total do(s) ciclo(s) selecionado(s): " + this.numberToDecimal(periodsTotalArea) + " ha"
    }
    // itemTotalPrice: function() {
    //   this.entry.price = _.round((this.entry.price ? this.entry.price : 0) * (this.entry.purchaseQuantity ? this.entry.purchaseQuantity : 0), 2);
    //   return this.entry.price;
    // }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if (!this.entry.item || this.entry.item.name != this.itemsSearch) {
          this.getPlanningItems();
        }
      }
    }
  },
  methods: {
    planningItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Consumo: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '')
      }
      return info;
    },
    selectItem: function() {
      this.entry.item = this.planningItemsList.find(obj => obj.id == this.entry.itemId);
    },
    changeApplicationDose: function() {
      if (this.applicationDose > 0) {
        let periodsTotalArea = this.planningOperation.periods.map(item => item.area).reduce((a, b) => a + b, 0)
        this.entry.quantity = _.round(this.applicationDose * periodsTotalArea, 10);
        this.quantityKey += 1;
        this.updateQuantityValues();
      }
    },
    updateApplicationDose: function(){
      if (this.entry.quantity > 0) {
        let periodsTotalArea = this.planningOperation.periods.map(item => item.area).reduce((a, b) => a + b, 0)
        this.applicationDose = _.round(this.entry.quantity / periodsTotalArea, 10);
        this.applicationDoseKey += 1;
      }
    },
    changeQuantity: function() {
      // console.log("purchaseQuantity", this.entry.purchaseQuantity);
      this.updateApplicationDose();
      this.updateQuantityValues();
    },
    updateQuantityValues:function() {
      if (this.entry.unitPrice > 0) {
        this.calculateTotalPrice();
      } else if (this.entry.price > 0) {
        this.calculateUnitPrice();
      } else {
        this.entry.price = 0;
        this.totalPriceKey--;
        this.entry.unitPrice = 0;
        this.unitPriceKey++;
      }
    },
    changeUnitPrice: function() {
      // console.log("unitPrice", this.entry.price);
      if (this.entry.quantity > 0) {
        this.calculateTotalPrice();
      }
    },
    changeTotalPrice: function() {
      // console.log("price", this.entry.price);
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice();
      }
    },
    calculateTotalPrice: function() {
      // console.log("calculateTotalPrice before", this.entry.price, this.entry.price);
      this.entry.price = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.quantity ? this.entry.quantity : 0), 10);
      // console.log("calculateTotalPrice depois", this.entry.price, this.entry.price);
      this.totalPriceKey--;
    },
    calculateUnitPrice: function() {
      // console.log("calculateUnitPrice before", this.entry.price, this.entry.price);
      this.entry.unitPrice = _.round((this.entry.price ? this.entry.price : 0) / (this.entry.quantity ? this.entry.quantity : 0), 10);
      // console.log("calculateUnitPrice after", this.entry.price, this.entry.price);
      this.unitPriceKey++;
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    getPlanningItems: function() {
      this.planningItemsListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_ITEMS_FOR_PLANNING_OPERATION_QUERY,
          variables: {
            query: this.itemsSearch,
            operationTypeId: this.planningOperation.operationTypeId,
            periodIds: this.planningOperation.periodIdsAttribute
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.planningItemsList = response.data.accountGlobalSharedContext.allPlanningAvailableItems;
          // console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.planningItemsListLoading = false));
    },
    clearFields: function() {
      this.forceRerender(this);
    },
  }
};

const LOAD_ALL_ITEMS_FOR_PLANNING_OPERATION_QUERY = gql`
query ($query: String!, $operationTypeId: ID!, $periodIds: [ID!]!) {
	accountGlobalSharedContext {
    allPlanningAvailableItems(query: $query, operationTypeId: $operationTypeId, periodIds: $periodIds) {
      id
      name
      type
      unit {
        name
      }
      brand {
        name
      }
      typeText
    }
  }
}`;


</script>

<style scoped></style>
